export const VERSION = '0.2.0-beta.2';
